import { LoggerProvider, BatchLogRecordProcessor } from '@opentelemetry/sdk-logs';
import { OTLPLogExporter } from '@opentelemetry/exporter-logs-otlp-http';
import { resourceFromAttributes } from '@opentelemetry/resources';
import { logs } from '@opentelemetry/api-logs';

const exporter = new OTLPLogExporter({
  url: `${import.meta.env.VITE_API_URL}/api/v1/telemetry/v1/logs`,
  headers: async () => {
    let fields = {
      "Yuzu-Key": import.meta.env.VITE_API_KEY,
    };
    if (localStorage.getItem("auth_token")) {
      fields["Authorization"] = `Bearer ${localStorage.getItem("auth_token")}`;
    }
    return fields;
  },
});


const loggerProvider = new LoggerProvider({
  processors: [new BatchLogRecordProcessor(exporter)],
  resource: resourceFromAttributes({
    'service.name': 'frontend-orga',
    'service.version': '1.0.0',
    'service.environment': import.meta.env.VITE_ENV || 'dev',
  }),
});

logs.setGlobalLoggerProvider(loggerProvider);

// Get a logger instance
export const logger = loggerProvider.getLogger('frontend');